import { GalleryInfo } from "kreate-common/modules/business-types";

import { EM_DASH } from "@/modules/common-utils/unicode";
import { getShortenedAddress } from "@/modules/kreate-components/components/AddressViewer/utils";

export function getPageTitle({
  galleryInfo,
  addressIsh,
}: {
  galleryInfo: GalleryInfo | null | undefined;
  addressIsh: string;
}) {
  const defaultTitle = addressIsh.startsWith("$")
    ? addressIsh
    : getShortenedAddress(addressIsh, { prefixLength: 8, suffixLength: 8 });

  return [
    "Sent Offers",
    galleryInfo?.title || defaultTitle || EM_DASH,
    "Kreate",
  ].join(" | ");
}

export const getPageTitle$PageGalleryCollector$SentOffers = getPageTitle;
